// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Action Bar Component (4 Single Buttons)
// ═══════════════════════════════════════════════════════════════════════════
// Reflect | Context | Save | Share
// ═══════════════════════════════════════════════════════════════════════════

import { icons } from './icons.js';
import { SETTINGS } from '../config/settings.js';

export function createActionBar(handlers = {}) {
  const {
    onReflect,
    onContext,
    onHeart,
    onShare,
  } = handlers;

  const bar = document.createElement('div');
  bar.className = 'action-bar';
  bar.id = 'action-bar';

  bar.innerHTML = `
    <button class="action-btn reflect-btn" data-action="reflect" aria-label="Reflect on this verse">
      ${icons.meditation}
      <span>Reflect</span>
    </button>
    
    <button class="action-btn context-btn" data-action="context" aria-label="Explore context">
      ${icons.book}
      <span>Context</span>
    </button>
    
    ${SETTINGS.features.favorites ? `
      <button class="action-btn heart-btn" data-action="heart" aria-label="Save to favorites">
        ${icons.heart}
        <span>Save</span>
      </button>
    ` : ''}
    
    ${SETTINGS.features.sharing ? `
      <button class="action-btn share-btn" data-action="share" aria-label="Share verse">
        ${icons.share}
        <span>Share</span>
      </button>
    ` : ''}
  `;

  // Event handlers
  setupActionBarHandlers(bar, { onReflect, onContext, onHeart, onShare });

  return bar;
}

function setupActionBarHandlers(bar, handlers) {
  const { onReflect, onContext, onHeart, onShare } = handlers;

  const reflectBtn = bar.querySelector('.reflect-btn');
  const contextBtn = bar.querySelector('.context-btn');
  const heartBtn = bar.querySelector('.heart-btn');
  const shareBtn = bar.querySelector('.share-btn');

  // Reflect button
  if (reflectBtn && onReflect) {
    reflectBtn.addEventListener('click', onReflect);
  }

  // Context button
  if (contextBtn && onContext) {
    contextBtn.addEventListener('click', onContext);
  }

  // Heart button with animation
  if (heartBtn && onHeart) {
    heartBtn.addEventListener('click', () => {
      heartBtn.classList.add('animating');
      setTimeout(() => heartBtn.classList.remove('animating'), 400);

      if (SETTINGS.enableHaptics && navigator.vibrate) {
        navigator.vibrate(10);
      }

      onHeart();
    });
  }

  // Share button
  if (shareBtn && onShare) {
    shareBtn.addEventListener('click', onShare);
  }
}

export function updateHeartState(isActive) {
  const heartBtn = document.querySelector('.heart-btn');
  if (!heartBtn) return;

  if (isActive) {
    heartBtn.classList.add('active');
    heartBtn.innerHTML = `${icons.heartFilled}<span>Saved</span>`;
  } else {
    heartBtn.classList.remove('active');
    heartBtn.innerHTML = `${icons.heart}<span>Save</span>`;
  }
}

export default { createActionBar, updateHeartState };
